import { h, Fragment } from "preact";
import { useState, useContext } from "preact/hooks";
import { SimpleReferralWidgetContext } from "../index";
import {
  calculateForeground,
  traceWidgetLoad
} from "../../../internal_utilities/utilities";
import ChatIcon from "../../../_components/Icons/ChatIcon";
import HighlightedTitle from "../../../_components/HighlightedTitle";
import DeskShareOptions from "../../../_components/DeskShareOptions";

const ShareView = props => {
  const simpleReferralWidgetContext = useContext(SimpleReferralWidgetContext);
  const [isShareModalOpen, setIsShareModalOpen] = useState(false);
  const giftDetails =
    simpleReferralWidgetContext.viewStateHistory.currentView.params;

  const shareRootUrl =
    giftDetails.campaign.giftConfig.discountSharePageType &&
    giftDetails.campaign.giftConfig.discountSharePageType === "popup"
      ? `https://${window.location.host}`
      : `https://${window.location.host}/a/offers/gift`;

  const shareURL = `${shareRootUrl}?id=${
    giftDetails.campaign.campaignId
  }&name=${giftDetails.name}&code=${giftDetails.code}`;

  const shareViewTitleWordMap = [
    {
      placeholder: "<gift_offer>",
      value: `${giftDetails.campaign.giftConfig.discountValue * -1}${
        giftDetails.campaign.giftConfig.discountType === "percentage"
          ? "%"
          : ` ${window.Shopify.currency.active}`
      }`
    }
  ];

  const ShareContent = componentProps => {
    const [isClicked, setIsClicked] = useState(false);
    return (
      <a
        onClick={() => {
          traceWidgetLoad({
            name: `copied_${componentProps.type}`,
            domain: window.Shopify.shop,
            url: window.location.href,
            referrer: document.referrer || "",
            key: ["app_name", "widget_type"],
            value: [
              "offerscorner",
              simpleReferralWidgetContext.currentCampaign.type
            ],
            operatingSystem: window.navigator.userAgentData
              ? window.navigator.userAgentData.platform
              : window.navigator.platform,
            screenSize: window.screen
              ? `${window.screen.width}-${window.screen.height}`
              : "",
            browserVersion: window.navigator.userAgentData
              ? window.navigator.userAgentData.brands[0].version
              : "",
            browser: window.navigator.userAgentData
              ? window.navigator.userAgentData.brands[0].brand
              : ""
          });
          navigator.clipboard.writeText(componentProps.content);
          setIsClicked(true);
          setTimeout(function() {
            setIsClicked(false);
          }, 3000);
        }}
        id="coca-share-content"
        className="flex rounnded-lg text-left items-center items-stretch border border-solid border-gray-300 overflow-hidden justify-between mt-2 rounded-lg"
      >
        {isClicked ? (
          <p className="font-bold text-base p-4 whitespace-nowrap overflow-hidden text-ellipsis">
            Copied to clipboard
          </p>
        ) : (
          <p className="font-bold text-base p-4 whitespace-nowrap overflow-hidden text-ellipsis">
            {componentProps.content}
          </p>
        )}
        <div
          ref={node => {
            if (node)
              node.style.setProperty(
                "background",
                `${highlightColor}`,
                "important"
              );
          }}
          className=" shrink-0 flex items-center px-2 justify-center"
        >
          <svg
            id="coca-share-content-icon"
            className=" font-bold mr-1"
            width="12"
            height="15"
            viewBox="0 0 12 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect
              x="0.5"
              y="0.5"
              width="8"
              height="10"
              rx="2.5"
              stroke={
                calculateForeground(highlightColor) === "white"
                  ? "white"
                  : "black"
              }
            />
            <rect
              x="3.5"
              y="4.5"
              width="8"
              height="10"
              rx="2.5"
              stroke={
                calculateForeground(highlightColor) === "white"
                  ? "white"
                  : "black"
              }
            />
          </svg>
          <span
            ref={node => {
              if (node)
                node.style.setProperty(
                  "color",
                  `${
                    calculateForeground(highlightColor) === "white"
                      ? "rgba(255,255,255,1)"
                      : "rgba(0,0,0,.6)"
                  }`,
                  "important"
                );
            }}
          >
            {" "}
            <b>
              {simpleReferralWidgetContext.currentLanguage &&
              simpleReferralWidgetContext.currentLanguage.copy
                ? simpleReferralWidgetContext.currentLanguage.copy
                : "Copy"}
            </b>
          </span>
        </div>
      </a>
    );
  };

  const highlightColor = simpleReferralWidgetContext.currentCampaign
    .thankyouPageConfig.popupThemeColor
    ? simpleReferralWidgetContext.currentCampaign.thankyouPageConfig
        .popupThemeColor
    : simpleReferralWidgetContext.currentCampaign.thankyouPageConfig.bgEndColor;

  return (
    <Fragment>
      <div id="coca-share-view-main-content-wrapper" className="grow pt-2">
        <div className="flex justify-center mt-2  ">
          <ChatIcon color={highlightColor} />
        </div>
        <h1
          id="coca-referral-share-view-hero-text"
          className=" font-bold text-2xl text-center p-2"
        >
          {simpleReferralWidgetContext.currentLanguage &&
          simpleReferralWidgetContext.currentLanguage.gift_offer_title ? (
            <HighlightedTitle
              color={highlightColor}
              text={
                simpleReferralWidgetContext.currentLanguage.gift_offer_title
              }
              wordMap={shareViewTitleWordMap}
            />
          ) : (
            <span>
              Share this invite link with your friend to gift them{" "}
              <span
                ref={node => {
                  if (node) {
                    node.style.setProperty(
                      "background",
                      `${highlightColor}`,
                      "important"
                    );
                    node.style.setProperty(
                      "color",
                      `${
                        calculateForeground(highlightColor) === "white"
                          ? "rgba(255,255,255,1)"
                          : "rgba(0,0,0,.6)"
                      }`,
                      "important"
                    );
                  }
                }}
                className="coca-referral-hero-highlight rounded-lg p-1"
              >
                {giftDetails.campaign.giftConfig.discountValue * -1}
                {giftDetails.campaign.giftConfig.discountType === "percentage"
                  ? "%"
                  : ` ${window.Shopify.currency.active}`}
              </span>{" "}
              discount
            </span>
          )}
        </h1>
        <div id="coca-share-content-wrapper" className=" max-w-md p-5">
          <p className="text-center">
            {simpleReferralWidgetContext.currentLanguage &&
            simpleReferralWidgetContext.currentLanguage
              .gift_offer_share_url_title
              ? simpleReferralWidgetContext.currentLanguage
                  .gift_offer_share_url_title
              : "You get rewarded when your friends makes a purchase"}
          </p>
          <ShareContent type="gift_url" content={shareURL} />
          {/* <p className="coca-text-center">or</p>
          <p>
            {simpleReferralWidgetContext.currentLanguage &&
            simpleReferralWidgetContext.currentLanguage
              .gift_offer_share_code_title
              ? simpleReferralWidgetContext.currentLanguage
                  .gift_offer_share_code_title
              : "Share this Coupon code with your friends"}
          </p>
          <ShareContent type="gift_code" content={giftDetails.code} /> */}
        </div>
      </div>
      <div
        id="coca-share-view-buttons-wrapper"
        className=" px-2 py-3 font-bold shrink-0 flex flex-col items-stretch"
      >
        {/* offer terms */}
        <a
          onClick={() => {
            traceWidgetLoad({
              name: `clicked_offerterms`,
              domain: window.Shopify.shop,
              url: window.location.href,
              referrer: document.referrer || "",
              key: ["app_name", "widget_type"],
              value: [
                "offerscorner",
                simpleReferralWidgetContext.currentCampaign.type
              ],
              operatingSystem: window.navigator.userAgentData
                ? window.navigator.userAgentData.platform
                : window.navigator.platform,
              screenSize: window.screen
                ? `${window.screen.width}-${window.screen.height}`
                : "",
              browserVersion: window.navigator.userAgentData
                ? window.navigator.userAgentData.brands[0].version
                : "",
              browser: window.navigator.userAgentData
                ? window.navigator.userAgentData.brands[0].brand
                : ""
            });
            simpleReferralWidgetContext.viewStateHistory.goTo(
              "offer-terms",
              giftDetails.campaign.offerTerms
            );
          }}
          id="corner-offer-terms-button"
          className="coca-thank-big-button mb-2 px-2 py-3 rounded-md text-center cursor-pointer text-base"
          ref={node => {
            if (node) {
              node.style.setProperty(
                "border",
                `1px solid #cecece`,
                "important"
              );
              node.style.setProperty("color", `#232222`, "important");
            }
          }}
        >
          {" "}
          {simpleReferralWidgetContext.currentLanguage &&
          simpleReferralWidgetContext.currentLanguage.offer_terms
            ? simpleReferralWidgetContext.currentLanguage.offer_terms
            : "Offer Terms"}
        </a>
        {/* share options desktop */}
        <a
          onClick={() => {
            traceWidgetLoad({
              name: `clicked_desk_share_options`,
              domain: window.Shopify.shop,
              url: window.location.href,
              referrer: document.referrer || "",
              key: ["app_name", "widget_type"],
              value: [
                "offerscorner",
                simpleReferralWidgetContext.currentCampaign.type
              ],
              operatingSystem: window.navigator.userAgentData
                ? window.navigator.userAgentData.platform
                : window.navigator.platform,
              screenSize: window.screen
                ? `${window.screen.width}-${window.screen.height}`
                : "",
              browserVersion: window.navigator.userAgentData
                ? window.navigator.userAgentData.brands[0].version
                : "",
              browser: window.navigator.userAgentData
                ? window.navigator.userAgentData.brands[0].brand
                : ""
            });
            setIsShareModalOpen(true);
          }}
          data-action="share/whatsapp/share"
          target="_blank"
          id="corner-offer-share-options-desktop"
          className="coca-thank-big-button mb-2 px-2 py-3 rounded-md text-center cursor-pointer text-base hidden md:block"
          ref={node => {
            if (node)
              node.style.setProperty("background", `#EBEBEB`, "important");
          }}
        >
          <span
            ref={node => {
              if (node) node.style.setProperty("color", `#010101`, "important");
            }}
          >
            {" "}
            {simpleReferralWidgetContext.currentLanguage &&
            simpleReferralWidgetContext.currentLanguage.other_share_options_text
              ? simpleReferralWidgetContext.currentLanguage
                  .other_share_options_text
              : "SHARE OPTIONS"}
          </span>
        </a>
        {/* share options MObile */}
        <a
          onClick={() => {
            traceWidgetLoad({
              name: `clicked_mobile_share_options`,
              domain: window.Shopify.shop,
              url: window.location.href,
              referrer: document.referrer || "",
              key: ["app_name", "widget_type"],
              value: [
                "offerscorner",
                simpleReferralWidgetContext.currentCampaign.type
              ],
              operatingSystem: window.navigator.userAgentData
                ? window.navigator.userAgentData.platform
                : window.navigator.platform,
              screenSize: window.screen
                ? `${window.screen.width}-${window.screen.height}`
                : "",
              browserVersion: window.navigator.userAgentData
                ? window.navigator.userAgentData.brands[0].version
                : "",
              browser: window.navigator.userAgentData
                ? window.navigator.userAgentData.brands[0].brand
                : ""
            });
            let text = `Hey, enjoy this gift of  ${giftDetails.campaign
              .giftConfig.discountValue * -1} ${
              giftDetails.campaign.giftConfig.discountType === "percentage"
                ? "%"
                : ` ${window.Shopify.currency.active}`
            } discount on ${
              window.location.host
            }. Visit the link below to avail it `;

            if (navigator.share) {
              navigator
                .share({
                  title: "Discount Coupon",
                  text: text,
                  url: `${shareURL}`
                })
                .then(() => {
                  console.log("Thanks for sharing!");
                })
                .catch(console.error);
            } else {
              window.alert(
                "This option is not supported in your browser try sharing manually by copying the link "
              );
            }
          }}
          data-action="share/whatsapp/share"
          target="_blank"
          id="corner-offer-share-options-mobile"
          className=" coca-thank-big-button mb-1 px-2 py-3 rounded-md text-center cursor-pointer text-base grow block md:hidden"
          ref={node => {
            if (node)
              node.style.setProperty("background", `#EBEBEB`, "important");
          }}
        >
          <span
            ref={node => {
              if (node) node.style.setProperty("color", `#010101`, "important");
            }}
          >
            {" "}
            {simpleReferralWidgetContext.currentLanguage &&
            simpleReferralWidgetContext.currentLanguage.other_share_options_text
              ? simpleReferralWidgetContext.currentLanguage
                  .other_share_options_text
              : "SHARE OPTIONS"}
          </span>
        </a>
      </div>
      <DeskShareOptions
        isOpen={isShareModalOpen}
        onClose={() => setIsShareModalOpen(false)}
        giftDetails={giftDetails}
        shareURL={shareURL}
        currentLanguage={simpleReferralWidgetContext.currentLanguage}
        currentCampaign={simpleReferralWidgetContext.currentLanguage}
      />
    </Fragment>
  );
};

export default ShareView;
